export default "__VITE_ASSET__Bs5mcXFZ__"